import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

import { DASHBOARD_ID_PARAMETER_NAME } from '../../constants';
import { DashboardDetails } from '../DashboardDetails/DashboardDetails';
import { TableDrawerEmptyState } from '@/components/ui/TableDrawerEmptyState';

export const DashboardDrawer = () => {
  const [searchParams] = useSearchParams();
  const selectedDashboardId = searchParams.get(DASHBOARD_ID_PARAMETER_NAME);

  const { t } = useTranslation('dashboardsOverview');

  if (!selectedDashboardId || selectedDashboardId === '') {
    return <TableDrawerEmptyState text={t('DrawerEmptyState')} />;
  }

  return <DashboardDetails dashboardId={selectedDashboardId} />;
};
